import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'

export const StyledCardLink = styled.a`
  color: inherit;
  display: block;
  position: relative;
  text-decoration: none;
  z-index: 0;
`

export const StyledCardButton = styled.button`
  background: transparent;
  border: 0;
  color: inherit;
  cursor: pointer;
  display: block;
  padding: 0;
  position: relative;
  text-align: left;
  width: fit-content;
  z-index: 0;
`

export const StyledCardPlaceholder = styled.div`
  ${s({
    alignItems: 'center',
    bgcolor: 'colorBackground02',
    borderRadius: 'borderRadius03',
    boxShadow: 'boxShadow01',
    display: 'flex',
    justifyContent: 'center',
    px: 4,
  })}

  width: 160px;
  min-width: 160px;
  height: 240px;
  position: relative;
  overflow: hidden;
`

export const StyledCardImageStack = styled.div`
  position: relative;
  width: 100%;
  max-width: 128px;
  margin: 0 auto;
`

export const StyledCardOpenLayer = styled.div`
  ${s({
    bgcolor: 'colorBackground01',
  })}

  position: absolute;
  top: -14px;
  left: 0;
  width: 120px;
  height: 14px;
  clip-path: polygon(100% 100%, 100% 0, 0 100%);
`

export const StyledCardImage = styled.img`
  display: block;
  width: 100%;
  max-width: 128px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`

export const StyledCardImageFallback = styled.div`
  ${s({
    alignItems: 'center',
    color: 'colorTextBody',
    display: 'flex',
    justifyContent: 'center',
    px: 2,
    typography: 'typeBodyCaption',
  })}

  width: 100%;
  min-height: 160px;
  text-align: center;
`
